// front-end equivalent to https://git.hubteam.com/HubSpot/InboundDb/blob/master/InboundDbBase/src/main/java/com/hubspot/inbounddb/base/MultiValuePropertyHelper.java
import { List } from 'immutable';
const SEPARATOR = ';';
export function parsePropertyValueToList(value) {
  if (!value) {
    return List();
  }

  return List(value.split(SEPARATOR)).map(result => result.trim()).filter(separatedValue => !!separatedValue);
}
export function formatListToPropertyValue(valueList) {
  return valueList ? valueList.join(SEPARATOR) : '';
}